import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, ChartOptions } from 'chart.js';
import { CHART_CONFIG } from '@core/constants/chartConfig.ts';

// Register Chart.js components
ChartJS.register(ArcElement, Tooltip, Legend);

interface DoughnutChartProps {
    data?: number[];
    labels?: string[];
    colors?: string[];
    style?: React.CSSProperties;
}

const DoughnutChart: React.FC<DoughnutChartProps> = ({
    data = [250, 25, 125],
    labels = ['Total Request', 'New', 'Pending'],
    colors = [CHART_CONFIG.color.primary, CHART_CONFIG.color.warning, CHART_CONFIG.color.danger],
    style
}) => {
    const options: ChartOptions<'doughnut'> = {
        responsive: true,
        plugins: {
            legend: {
                display: false
            }
        },
        cutout: '60%',
        maintainAspectRatio: false
    };

    const chartData = {
        labels,
        datasets: [
            {
                data,
                backgroundColor: colors,
                hoverBackgroundColor: colors,
                borderWidth: 0
            }
        ]
    };

    return (
        <div style={style}>
            <Doughnut data={chartData} options={options} />
        </div>
    );
};

export default DoughnutChart;
